import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as fromRoot from '../reducers';
import * as actions from '../actions/site';
import { Store } from '@ngrx/store';
import { ListItem } from '../../core/models/list-item';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-site-editor',
  template: `
   <irar-site-form [site]="selectedSite$ | async"
     (save)="saveSite($event)"></irar-site-form>
  `
})
export class AdminManageSiteContainerComponent {
  siteId: number;
  selectedSite$: Observable<ListItem>;

  constructor(private route: ActivatedRoute,
    private store: Store<fromRoot.State>) {
    this.siteId = +this.route.snapshot.params['id'];
    this.selectedSite$ = this.store.select(fromRoot.getSelectedSite);
    this.store.dispatch(new actions.SelectSiteByIdAction(this.siteId));
  }

  saveSite(e: ListItem) {
    this.store.dispatch(new actions.UpdateSiteAction(e));
  }
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/containers/admin-manage-site.ts